import React from "react";

interface FolderIconProps {
  className?: string;
  onClick?: () => void;
}

export const FolderIcon = ({ className, onClick }: FolderIconProps) => (
  <svg
    className={className}
    onClick={onClick}
    width="21"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.14062 1.5H2.25C2.03125 1.5 1.84375 1.57813 1.6875 1.73438C1.5625 1.85938 1.5 2.03125 1.5 2.25V15.75C1.5 15.9688 1.5625 16.1562 1.6875 16.3125C1.84375 16.4375 2.03125 16.5 2.25 16.5H21.75C21.9688 16.5 22.1406 16.4375 22.2656 16.3125C22.4219 16.1562 22.5 15.9688 22.5 15.75V5.25C22.5 5.03125 22.4219 4.85938 22.2656 4.73438C22.1406 4.57813 21.9688 4.5 21.75 4.5H12.75C12.3438 4.5 11.9844 4.35938 11.6719 4.07812L9.14062 1.5ZM2.25 0H9.14062C9.54688 0 9.89062 0.140625 10.1719 0.421875L12.75 3H21.75C22.375 3 22.9062 3.21875 23.3438 3.65625C23.7812 4.09375 24 4.625 24 5.25V15.75C24 16.375 23.7812 16.9062 23.3438 17.3438C22.9062 17.7812 22.375 18 21.75 18H2.25C1.625 18 1.09375 17.7812 0.65625 17.3438C0.21875 16.9062 0 16.375 0 15.75V2.25C0 1.625 0.21875 1.09375 0.65625 0.65625C1.09375 0.21875 1.625 0 2.25 0Z"
      fill="black"
    />
  </svg>
);

FolderIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
